import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable'

import { ApiClient } from '../api-client';
import { Survey } from './survey';

@Injectable()
export class SurveyService extends ApiClient {
  store: Subject<Survey[]>;
  path = '/surveys';
  model = Survey;

  constructor(protected http: Http) {
    super(http);
    this.store = <Subject<Survey[]>>new Subject();
  }

  createSurveyRespondent(survey_id: string, survey: Object): Observable<any> {
    const url = `${this.baseUrl}/surveys/${survey_id}/respondents`;

    return this.post(url, survey);
  }

  calculateScore(survey_id: string, survey: Object): Observable<any> {
    const url =  `${this.baseUrl}/surveys/${survey_id}/calculate_score`;

    return this.post(url, survey);
  }
}



// WEBPACK FOOTER //
// ./src/app/api/resources/survey.service.ts